module.exports = __webpack_public_path__ + "img/bt.dbb1623f.svg";